export default {
    'grapesjs-object-fit': {
        'fill': 'Füllen',
        'contain': 'Enthalten',
        'cover': 'Überdecken',
        'none': 'Kein',
        'scale-down': 'Skalieren',
    },
};
